import { render, staticRenderFns } from "./InstallmentView.vue?vue&type=template&id=3d60675f"
import script from "./InstallmentView.vue?vue&type=script&lang=js"
export * from "./InstallmentView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports